import { useState, useCallback } from 'react';
import { getCustomGroupUsers} from '../api/customGroupsHttpClient';
import { FetchDataRequest, FetchDataResult } from "../../../Common/models/grid";

export const useCustomGroupUsers = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [users, setUsers] = useState<FetchDataResult>({
    rows: [],
    totalRows: 0,
  });

  const fetchUsers = useCallback(async (
    projectId: string, 
    toolId: string,
    groupName: string,
    request: FetchDataRequest
  ) => {
    setLoading(true);
    setError(null);
    try {
      const result = await getCustomGroupUsers(projectId, toolId, groupName, request);
      setUsers(result);
      return result;
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An error occurred while fetching users');
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  const clearUsers = useCallback(() => {
    setUsers({
      rows: [],
      totalRows: 0,
    });
    setError(null);
  }, []);


  return {
    users,
    loading,
    error,
    fetchUsers,
    clearUsers
  };
};